import { observer } from "mobx-react-lite";
import {Fragment, useEffect} from "react";
import "./index.css";
import {AddCompanyStore, CommonStore, HomeStore} from "../../store";
import { Card, Col, Row, Statistic ,Button} from "antd";
import ANumber from "./a_number";
import XNumber from "./x_number";
import AccountDetail from './accountDetail'
import {ExclamationCircleOutlined,ClockCircleOutlined,CheckCircleOutlined} from "@ant-design/icons";
import AddCompany from "../choose_company/addCompany";
import RecordDetails from "./record_details";
import ApprovalDetails from "./approval_details";

function Home() {
    useEffect(()=>{
        CommonStore.getHomePageData()
    },[])
    const enterpriseCertification = () => {
      if (!CommonStore.homePageDataList.authStatus){
          //未认证
          HomeStore.setProcess('企业认证')
          AddCompanyStore.addCompanyModal.open('add')
      }else if(CommonStore.homePageDataList.authStatus==='IN_PROGRESS'){
          //认证中
          HomeStore.detailModal.open('enterprise')
      }else if(CommonStore.homePageDataList.authStatus==='APPROVED'){
          //已认证
          HomeStore.detailModal.open('enterprise')
      }else if(CommonStore.homePageDataList.authStatus==='AUTH_UPDATE'){
          //认证变更中
          HomeStore.detailModal.open('enterprise')
      }else if(CommonStore.homePageDataList.authStatus==='FAILED'){
          // 认证失败
          HomeStore.setProcess('企业认证')
          AddCompanyStore.addCompanyModal.open('update','企业认证')
      }
    }
  return (
    <Fragment>
        <AddCompany process={HomeStore.process}/>
        <AccountDetail/>
        <RecordDetails/>
        <ApprovalDetails/>
      <Row
        style={{border: "1px solid rgb(245 245 245)", padding: "10px", margin: "15px",}}
      >
        <Col span={9}>
          <div>
            <div className={"titleSty"}>
              欢迎回来，{CommonStore.userInfo.accountDisplayName}
            </div>
            <div style={{ width: "100%" }}>
              <div style={{ margin: "10px"}}>
                  {CommonStore.homePageDataList.authStatus?'企业名称':'账户名称'}：{CommonStore.homePageDataList.authStatus?CommonStore.userInfo.customerDisplayName:CommonStore.userInfo.organizationDisplayName}
                  {!CommonStore.homePageDataList.authStatus&&<div className={'statusBtn'}><ExclamationCircleOutlined/>未认证</div>}
                  {CommonStore.homePageDataList.authStatus==='IN_PROGRESS'&&<div className={'statusBtn'} style={{color:'orange'}}><ClockCircleOutlined />认证中</div>}
                  {CommonStore.homePageDataList.authStatus==='APPROVED'&&<div className={'statusBtn'} style={{color:'green'}}><CheckCircleOutlined />已认证</div>}
                  {CommonStore.homePageDataList.authStatus==='AUTH_UPDATE'&&<div className={'statusBtn'} style={{color:'orange'}}><ClockCircleOutlined />认证变更中</div>}
                  {CommonStore.homePageDataList.authStatus==='FAILED'&&<div className={'statusBtn'}><ExclamationCircleOutlined/>认证失败</div>}
              </div>
                <div style={{ margin: "10px" }}>
                    {CommonStore.homePageDataList.authStatus?'账户名称':'账户编号'}：{CommonStore.homePageDataList.authStatus?CommonStore.userInfo.organizationDisplayName:CommonStore.userInfo.organizationNo}
              </div>
            </div>
              <div>
                  {CommonStore.userInfo.isAdmin && CommonStore.homePageDataList.authStatus!=='IN_PROGRESS'&&<Button type="link" style={{marginRight:'10px'}} onClick={enterpriseCertification}>企业认证</Button>}
                  {CommonStore.userInfo.isAdmin &&<Button type="link" style={{marginRight:'10px'}} onClick={()=>HomeStore.recordModal.open('enterprise')}>认证记录</Button>}
                  {CommonStore.userInfo.isAdmin && CommonStore.homePageDataList.authStatus&&CommonStore.homePageDataList.authStatus!=='FAILED' && CommonStore.homePageDataList.authStatus!=='IN_PROGRESS'&&<Button type="link" style={{marginRight:'10px'}} onClick={()=>HomeStore.detailModal.open('account')}>账户信息</Button>}
                  {CommonStore.userInfo.isAdmin &&CommonStore.homePageDataList.authStatus&&CommonStore.homePageDataList.authStatus!=='FAILED' && CommonStore.homePageDataList.authStatus!=='IN_PROGRESS'&&<Button type="link" style={{marginRight:'10px'}} onClick={()=>HomeStore.recordModal.open('account')}>账户变更记录</Button>}
              </div>
          </div>
        </Col>
        <Col span={5} style={{ paddingRight: "10px" }}>
          <Card bordered={false} style={{height:'100%'}}>
            <Statistic
              title="用户数量"
              value={CommonStore.homePageDataList.accountReadable?CommonStore.homePageDataList.userQuantity:'***'}
              valueStyle={{ color: "#3f8600",fontSize:'2.5rem' }}
            />
          </Card>
        </Col>
        <Col span={5} style={{ paddingRight: "10px" }}>
          <Card bordered={false} style={{height:'100%'}}>
            <Statistic
              title="A池数量"
              value={CommonStore.homePageDataList.apoolReadable?CommonStore.homePageDataList.apoolQuantity:'***'}
              valueStyle={{ color: "#3f8600",fontSize:'2.5rem' }}
            />
          </Card>
        </Col>
        <Col span={5} style={{ paddingRight: "10px" }}>
          <Card bordered={false} style={{height:'100%'}}>
            <Statistic
              title="X池数量"
              value={CommonStore.homePageDataList.xpoolReadable?CommonStore.homePageDataList.xpoolQuantity:'***'}
              valueStyle={{ color: "#3f8600",fontSize:'2.5rem' }}
            />
          </Card>
        </Col>
      </Row>
      <div style={{ margin: "15px 15px", padding: "10px" }}>
        <div className={"titleSty1"}>数据概览</div>
      </div>
      <div className="homeContentSty">
        <ANumber
          style={{
            height: "100%",
            width: "100%",
            display: "inline-block",
          }}
        ></ANumber>
        <XNumber
          style={{
            height: "100%",
            width: "100%",
            display: "inline-block",
          }}
        ></XNumber>
      </div>
    </Fragment>
  );
}

export default observer(Home);
